import React from "react";
import CustomDiv from "../../Shared/CustomDiv";
import { Carousel } from "react-responsive-carousel";
import Text from "../../Shared/Text";
import classNames from "classnames";
import CustomButton from "../../Shared/CustomButton";
import { sliderListFn } from "../../Services/SliderList";
import { useMutation, useQuery } from "react-query";
import { useState } from "react";
import { useEffect } from "react";
import { testimonialFn } from "../../Services/Testimonial";
import { bannerFn } from "../../Services/Banner";
import { useNavigate, useParams } from "react-router-dom";
import { productsFn } from "../../Services/Products";
import { categoryListFn } from "../../Services/CategoryList";
import { Divider } from "@mui/material";
const LandingPage = () => {
  const [open, setOpen] = useState(null);
  const [data, setData] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [banners, setBanners] = useState([]);
  const [spices, setSpices] = useState([]);
  const handleActiveHover = (id) => {
    setOpen(id);
  };
  const handleCloseHover = () => {
    setOpen(null);
  };

  const { mutate } = useMutation(sliderListFn, {
    onSuccess: (response) => {
      setData(response.data.data);
    },
  });
  const { mutate: testimonial } = useMutation(testimonialFn, {
    onSuccess: (response) => {
      setTestimonials(response.data.data);
    },
  });

  const { mutate: banner } = useMutation(bannerFn, {
    onSuccess: (response) => {
      setBanners(response.data.data);
    },
  });
  useEffect(
    () => {
      mutate();
      testimonial();
      banner();
    },
    // eslint-disable-next-line
    []
  );
  const navigate = useNavigate();
  const { mutate: productList } = useMutation(productsFn, {
    onSuccess: (response) => {
      setSpices(response?.data?.data.product_list);
    },
  });
  const { data: mainCategoryList } = useQuery(
    ["mainCategoryList"],
    () => categoryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  useEffect(
    () => {
      productList();
      // allFilters({
      //   category_id: 5,
      //   sub_category_id: "",
      //   brand_id: "",
      //   color_id: "",
      //   max_price: "",
      //   min_price: "",
      //   rating: "",
      // });
    },
    // eslint-disable-next-line
    []
  );

  return (
    <CustomDiv className="flex flex-col w-full">
      <Carousel
        autoPlay
        showStatus={false}
        showThumbs={false}
        className="shubhga-carousel"
      >
        {data?.map((slider) => {
          return (
            <div key={slider.id}>
              <img
                alt=""
                src={slider.image}
                className="relative pt-1 h-48 lg:h-auto"
              />
            </div>
          );
        })}
      </Carousel>
      <div className="flex justify-between !mt-4 px-4">
        <p className="font-bold">Shop By Categories </p>
        <p className="text-blue-600" onClick={() => navigate("/")}>
          See all
        </p>
      </div>
      <CustomDiv className="grid grid-cols-3 justify-center gap-4 p-4">
        {mainCategoryList?.data?.data?.main_category_list?.map((product) => {
          return (
            <>
              <div
                className="flex flex-col "
                onClick={() =>
                  navigate("/all-products", {
                    state: { from: "allproduct" },
                  })
                }
              >
                <img
                  src={product.image}
                  alt=""
                  className="h-16  w-16 rounded  border "
                />

                <span className=" truncate">{product.category}</span>
              </div>
            </>
          );
        })}
      </CustomDiv>
      <Divider />
      <div className="flex justify-between !mt-4 px-4">
        <p className="font-bold text-2xl">Today Deal </p>
      </div>

      <Carousel
        autoPlay
        showStatus={false}
        showThumbs={false}
        className="shubhga-carousel !m-2"
      >
        {banners?.slice?.(0, 4)?.map((ban) => {
          return (
            <div key={ban.id}>
              <img
                alt=""
                src={ban.image}
                className="relative  rounded-lg pt-1 h-52 lg:h-auto"
              />
            </div>
          );
        })}
      </Carousel>

      <div className="flex justify-between !mt-4 px-4">
        <p className="font-bold">Best Sellers </p>
        <p
          className="text-blue-600"
          onClick={() =>
            navigate("/all-products", {
              state: { from: "allproduct" },
            })
          }
        >
          See all
        </p>
      </div>
      <CustomDiv className="px-[1%] lg:px-[8%]">
        <CustomDiv className="flex gap-2 my-2 py-1 w-full hide-scroll overflow-x-auto">
          {spices?.map((product) => {
            return (
              <CustomDiv
                className="!rounded-md h-fit w-[150px] duration-200  cursor-pointer "
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="centerdiv">
                  <img
                    src={product.image}
                    alt=""
                    className="h-32 rounded-xl  border relative"
                  />
                </span>

                <CustomDiv className="flex flex-col justify-between p-4 ">
                  <CustomDiv className="">
                    <Text className="text-xs  font-semibold !truncate">
                      {product.title}
                    </Text>
                  </CustomDiv>
                  <Text className="text-xs uppercase">
                    {product.main_category}
                  </Text>
                  <CustomDiv className="flex items-center gap-3">
                    <Text className="">₹{product.price}</Text>

                    <Text className="text-green-600">
                      {product.discount_percent !== "0.0"
                        ? `(${product.discount_percent?.split(".0")})%`
                        : null}
                    </Text>
                  </CustomDiv>
                  {product.discount_percent !== "0.0" ? (
                    <Text className="">
                      <span className="!text-xs"> Price - </span> ₹
                      {product.actual_price}
                    </Text>
                  ) : null}
                </CustomDiv>
              </CustomDiv>
            );
          })}
        </CustomDiv>
      </CustomDiv>
      <Divider className="!my-2" />
      <p className="font-bold px-4 text-2xl">Top brand Sales </p>

      <Carousel
        autoPlay
        showStatus={false}
        showThumbs={false}
        className="shubhga-carousel !m-2"
      >
        {banners?.slice?.(2)?.map((ban) => {
          return (
            <div key={ban.id}>
              <img
                alt=""
                src={ban.image}
                className="relative pt-1 rounded-lg h-52 lg:h-auto"
              />
            </div>
          );
        })}
      </Carousel>

      <div className="flex justify-between  my-2 px-4">
        <p className="font-bold text-xl">Product </p>
        <p
          className="text-blue-600"
          onClick={() =>
            navigate("/all-products", {
              state: { from: "allproduct" },
            })
          }
        >
          See all
        </p>
      </div>
      <Divider />
      <CustomDiv className="px-[2%] py-4 lg:px-[8%]">
        <CustomDiv className="grid grid-cols-3 gap-2">
          {spices?.map((product) => {
            return (
              <CustomDiv
                className=""
                onClick={() =>
                  navigate(`/product/${product?.id}/${product?.variant_id}`)
                }
              >
                <span className="">
                  <img
                    src={product.image}
                    alt=""
                    className="h-20 rounded-full border border-black "
                  />
                </span>

                <CustomDiv className="flex flex-col justify-between p-4 ">
                  <CustomDiv className="">
                    <Text className="text-xs  !truncate">{product.title}</Text>
                    <Text className="text-blue-800">₹{product.price}</Text>
                  </CustomDiv>
                </CustomDiv>
              </CustomDiv>
            );
          })}
        </CustomDiv>
      </CustomDiv>

      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        className="testimonial-carousel"
      >
        {testimonials?.map((testimonial) => {
          return (
            <CustomDiv className="flex flex-col h-[600px] lg:h-64 gap-2 lg:flex-row gradient justify-center items-center lg:px-[20%] px-[4%] py-3 mx-3">
              <img
                src={testimonial.image}
                alt=""
                style={{ border: "5px solid black" }}
                className="rounded-full !w-52 !p-2 !border-2 !border-white"
              />

              <CustomDiv className="flex flex-col text-white">
                <Text className="text-xl font-bold text-center">
                  {testimonial.name}
                </Text>
                <Text className="lg:pr-[10%] text-center">
                  {testimonial.message}
                </Text>
              </CustomDiv>
            </CustomDiv>
          );
        })}
      </Carousel>

      {/* <CustomDiv className="flex overflow-x-auto hide-scroll m-3">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item) => {
          return (
            <CustomDiv className="lg:w-1/2 h-80" key={item}>
              <img
                src={`https://source.unsplash.com/random/900×700/?food/${item}`}
                alt=""
                className="relative w-[295px] h-[295px] cursor-pointer"
              />
              <span
                onMouseEnter={() => handleActiveHover(item)}
                onMouseLeave={() => handleCloseHover(item)}
                className="relative overflow-hidden flex cursor-pointer justify-center items-center bottom-[19rem] pb-[108px] p-24 bg-white bg-opacity-0 hover:bg-opacity-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  fill="currentColor"
                  class="bi bi-instagram"
                  viewBox="0 0 16 16"
                  className={classNames(
                    "text-[#00BAF2] transition-all duration-700",
                    open === item
                      ? "scale-100 rotate-0"
                      : "scale-0 rotate-[-270deg]"
                  )}
                >
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
              </span>
            </CustomDiv>
          );
        })}
      </CustomDiv> */}
    </CustomDiv>
  );
};

export default LandingPage;
